module.exports = __webpack_public_path__ + "img/B高通锐化5.7ec609b4.png";